// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from "react";
import * as Provider from "./Provider";
import * as AuthBackend from "./AuthBackend";
import * as Setting from "../Setting";
import {goToWeb3Url} from "./ProviderButton";
import shenzhenIcon from "../assets/login/shenzhen.png";
import guangzhouIcon from "../assets/login/guangzhou.png";
import moreIcon from "../assets/login/more.png";
import arrowIcon from "../assets/login/arrow.png";
import "./RegionSelectPanel.less";

const REGION_CARDS = [
  {
    title: "深圳南山",
    description: "深圳总部 · 南山区科技园",
    actionText: "点击跳转钉钉登录",
    icon: shenzhenIcon,
  },
  {
    title: "广州",
    description: "广州分公司 · 天河区珠江新城",
    actionText: "点击跳转钉钉登录",
    icon: guangzhouIcon,
  },
];

const MORE_CARD = {
  title: "更多城市陆续接入中",
  description: "如需新增登录地区，请联系技术部工作人员",
  icon: moreIcon,
};

function goToSamlUrl(provider, location) {
  const params = new URLSearchParams(location.search);
  const clientId = params.get("client_id") ?? "";
  const state = params.get("state");
  const realRedirectUri = params.get("redirect_uri");
  const redirectUri = `${window.location.origin}/callback/saml`;
  const providerName = provider.name;
  const relayState = `${clientId}&${state}&${providerName}&${realRedirectUri}&${redirectUri}`;
  AuthBackend.getSamlLogin(`${provider.owner}/${providerName}`, btoa(relayState)).then((res) => {
    if (res.status === "ok") {
      if (res.data2 === "POST") {
        document.write(res.data);
      } else {
        window.location.href = res.data;
      }
    } else {
      Setting.showMessage("error", res.msg);
    }
  });
}

function handleProviderClick(application, provider, location) {
  if (provider.category === "SAML") {
    goToSamlUrl(provider, location);
  } else if (provider.category === "Web3") {
    goToWeb3Url(application, provider, "signup");
  } else {
    window.location.href = Provider.getAuthUrl(application, provider, "signup");
  }
}

function RegionCard({card, onClick, clickable}) {
  return (
    <div
      className={`region-select-card${clickable ? " region-select-card-clickable" : " region-select-card-placeholder"}`}
      onClick={clickable ? onClick : undefined}
      role={clickable ? "button" : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={clickable ? (e) => {if (e.key === "Enter") {onClick();}} : undefined}
    >
      <img className="region-select-card-icon" src={card.icon} alt={card.title} />
      <div className="region-select-card-content">
        <div className="region-select-card-title">{card.title}</div>
        <div className="region-select-card-desc">{card.description}</div>
        {card.actionText ? (
          <div className="region-select-card-action">{card.actionText} &gt;</div>
        ) : (
          <div className="region-select-card-dots">...</div>
        )}
      </div>
      {clickable ? <img className="region-select-card-arrow" src={arrowIcon} alt="" /> : null}
    </div>
  );
}

export default function RegionSelectPanel({application, providers, location}) {
  const regionCards = providers.slice(0, REGION_CARDS.length).map((providerItem, index) => ({
    ...REGION_CARDS[index],
    provider: providerItem.provider,
  }));

  return (
    <div className="region-select-panel">
      <div className="region-select-header">
        访问 <span className="region-select-app-name">{application.displayName}</span> 请选择登录地区
      </div>
      <div className="region-select-grid">
        {regionCards.map((card, index) => (
          <RegionCard
            key={index}
            card={card}
            clickable={true}
            onClick={() => handleProviderClick(application, card.provider, location)}
          />
        ))}
        <RegionCard card={MORE_CARD} clickable={false} />
      </div>
    </div>
  );
}
